export default __webpack_public_path__ + "static/media/externalLink.5d2384a2.svg";